export default {
    loading: {
        module: true,
        search_contact: false,
    },
    params: {
        year_month_from: '202005',
        year_month_up: null,
        account_from: null,
        account_up: null,
        description_account_from: null,
        description_account_up: null,
        contact_id: null,
        contact_identification: null,
    },
    params_contacts:{
        paginate: false,
        page: 1,
        perPage: 50,
        query: '',
        filter: '',
        sortBy: 'id',
        sort: 'ASC',
        only_active:true,
    },
    accounts_from: [],
    contacts:[],
    auxiliary_book:[],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    },
    subscriber : null
}



// WEBPACK FOOTER //
// ./src/modules/auxiliary-book-contact/state.js